import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { DeclarativeMapBase } from '../declarative-map-base/declarative-map-base.component';
import { explicitEffect } from 'ngxtension/explicit-effect';

@Component({
  selector: 'cue-declarative-map-image',
  imports: [],
  templateUrl: './declarative-map-image.component.html',
  styleUrl: './declarative-map-image.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeclarativeMapImageComponent extends DeclarativeMapBase {
  src = input<string>();
  width = input<number>();
  height = input<number>();
  fitMap = input(false);
  imageLoaded = output<boolean>();
  #imageSet = false;

  affectImage = explicitEffect([this.src, this.width, this.height], ([src, width, height]) => {
    if (src && width && height) {
      if (!this.#imageSet) {
        setTimeout(() => {
          this.addImage(src, width, height);
          this.#imageSet = true;
        }, 100);
      } else {
        setTimeout(() => {
          this.setImageSrc(src, width, height);
        }, 100);
      }
    }
  });

  affectFitMap = explicitEffect([this.fitMap], ([fitMap]) => {
    if (!this.#imageSet || !fitMap) {
      return;
    }

    this.focus();
  });

  focus() {
    this.adapter.focusImage(this.identifier);
  }

  private addImage(src: string, width: number, height: number) {
    this.adapter.addImage(this.identifier, src, width, height, this.fitMap());
    this.imageLoaded.emit(true);
  }

  private setImageSrc(src: string, width: number, height: number) {
    this.adapter.setImageSrc(this.identifier, src, width, height, this.fitMap());
    this.imageLoaded.emit(true);
  }
}
